import React from 'react';
import StoredLayout from 'layouts/StoredLayout';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { Row, Col, Button, Input } from 'reactstrap';
import CyderReactTable from 'cyder/table/CyderReactTable';
import Select from 'react-select';
import { getProductCategories } from 'actions/admin/product/product-sub-category/action';

import { search } from 'actions/admin/product/product-sub-category/action.js';

class ListPage extends React.Component {
    constructor(props) {
        super(props);
        this._isMounted = true;
        this.onKeywordChange = this.onKeywordChange.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        this.search = this.search.bind(this);
        this.state = {
            list: [],
            productCategories: [],
            filter: '',
            loading: false,
            pagination: true,
            keyword: '',
            pageSize: 10,
            pageCount: 0,
        };
    }
    componentDidMount() {
        this.getProductCategories();
    }
    async getProductCategories() {
        try {
            this.showLoading(true);
            const { data } = await this.props.getProductCategories();
            // PROCESS DATA
            const productCategories = data.map(({ id, category }) => {
                return {
                    value: id,
                    label: category,
                };
            });
            // SET STATE
            if (this._isMounted && data)
                this.setState({
                    productCategories,
                });
        } catch (error) {
            throw error;
        } finally {
            this.showLoading(false);
        }
    }
    showLoading(loading) {
        if (this._isMounted) this.setState({ loading });
    }
    onKeywordChange(e) {
        this.setState({
            keyword: e.target.value,
        });
    }
    onSelectChange(value) {
        this.setState({
            filter: value ? value.label : '',
        });
    }
    async search(page, pageSize, sorted, filtered) {
        try {
            this.showLoading(true);
            const { data, totalNoOfPages, totalNoOfItems } = await this.props.search(
                this.state.keyword,
                page,
                pageSize,
                sorted,
                filtered,
                this.state.filter,
            );
            if (this._isMounted) {
                this.setState({
                    list: data,
                    loading: false,
                    pageCount: totalNoOfPages,
                    totalNum: totalNoOfItems,
                });
            }
        } catch (error) {
            throw error;
        } finally {
            this.showLoading(false);
        }
    }
    render() {
        const columns = [
            { Header: 'ID', accessor: 'id', style: { whiteSpace: 'unset' }, maxWidth: 100 },
            {
                Header: 'Sub Category',
                accessor: 'subcategory',
                style: { whiteSpace: 'unset' },
            },
            {
                Header: 'Category Name',
                accessor: 'categoryName',
                style: { whiteSpace: 'unset' },
            },
            {
                Header: 'Low Voc',
                maxWidth: 150,
                accessor: 'enableLowVoc',
                style: { whiteSpace: 'unset' },
                Cell: props => {
                    return props.value == 1 ? 'Yes' : 'No';
                },
            },
            {
                Header: '',
                accessor: 'id',
                sortable: false,
                maxWidth: 50,
                Cell: props => {
                    return (
                        <Link to={'/admin/product/product-sub-category/' + props.value}>
                            <Button className="primary-btn-style">
                                <i className="mr-1 material-icons align-text-bottom ">edit</i>
                            </Button>
                        </Link>
                    );
                },
            },
        ];
        return (
            <div>
                <Row className="mb-2">
                    <Col xs={12}>
                        <Row className="form-inline">
                            <Col>
                                <Input
                                    style={{ float: 'left', marginRight: '5px' }}
                                    type="text"
                                    placeholder="Keyword"
                                    onKeyDown={e => {
                                        if (e.keyCode == 13) this.table.fireFetchData();
                                    }}
                                    onChange={this.onKeywordChange}
                                    value={this.state.keyword}
                                />
                                <div style={{ float: 'left', width: '200px', marginRight: '5px' }}>
                                    <Select
                                        classNamePrefix="select"
                                        placeholder="Product Category"
                                        isClearable={true}
                                        isLoading={this.state.loading}
                                        options={this.state.productCategories}
                                        onChange={this.onSelectChange}
                                    />
                                </div>
                                <Button className="ml-2 align-middle primary-btn-style" onClick={() => this.table.fireFetchData()}>
                                    <i className="material-icons align-text-bottom">search</i>
                                    &nbsp;Search
                                </Button>
                            </Col>
                            <div className="ml-auto">
                                <Link to="/admin/product/product-sub-category/0">
                                    <Button className="ml-1 mr-1 align-middle primary-btn-style">
                                        <i className="material-icons align-text-bottom">add</i>
                                        &nbsp;Add
                                    </Button>
                                </Link>
                            </div>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <CyderReactTable
                            manual
                            className="-highlight mb-2"
                            minRows={0}
                            filterable={false}
                            columns={columns}
                            data={this.state.list}
                            showPagination={this.state.pagination}
                            defaultPageSize={this.state.pageSize}
                            totalNum={this.state.totalNum}
                            pages={this.state.pageCount}
                            loading={this.state.loading}
                            ref={instance => {
                                if (instance != null) {
                                    this.table = instance.table;
                                }
                            }}
                            onFetchData={(state, instance) => {
                                this.search(state.page, state.pageSize, state.sorted, state.filtered);
                            }}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ownProps,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        search: (keyword, page, pageSize, sorted, filtered, filterType) => {
            return dispatch(search(keyword, page, pageSize, sorted, filtered, filterType));
        },
        getProductCategories: () => {
            return dispatch(getProductCategories());
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(StoredLayout(ListPage));
